import { useState } from "react"
import { useNavigate } from "react-router-dom";
import routes from "../constants/routes"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import TabPanel from "../components/ui/TabPanel"
import Expenses from "../components/accounting/Expenses"
import CashRegister from "../components/accounting/CashRegister"
import Accounts from "../components/accounting/Accounts"
import FeeSummary from "../components/accounting/FeeSummary"
import TabLogo from "../components/common/TabLogo"

const Accounting = ({tab}) => {
  const [value, setValue] = useState(tab || 0)
  const navigate = useNavigate()
  const handleChange = (_, newValue) => {
    setValue(newValue)
    switch(newValue) {
      case 0:
        navigate(routes.ACCOUNTING.MYEXPENSES, {replace: true})
        break
      case 1:
        navigate(routes.ACCOUNTING.CASHREGISTER, {replace: true})
        break
      case 2:
        navigate(routes.ACCOUNTING.ACCOUNTS, {replace: true})
        break
      case 3:
        navigate(routes.ACCOUNTING.FEES, {replace: true})
        break
      default:
        navigate(routes.ACCOUNTING.MYEXPENSES, {replace: true})
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction="row" sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabLogo />
        <Tabs value={value} onChange={handleChange}>
          <Tab label="My Expenses" />
          <Tab label="Cash Register" />
          <Tab label="Accounts" />
          <Tab label="Fees" />
        </Tabs>
      </Stack>
      <TabPanel value={value} index={0}>
        <Expenses />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CashRegister />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Accounts />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <FeeSummary />
      </TabPanel>
    </Box>
  )
}

export default Accounting
